import { Component, ViewChild } from '@angular/core';
import {  NavController, NavParams, ModalController, ActionSheetController } from 'ionic-angular';
import { CalendarComponentOptions } from 'ion2-calendar';
import { BllOrtak } from '../../providers/bll/bll-ortak';
import { Ortak } from '../../providers/ortak';
import { PerakendeFaturaDetayPage } from '../faturaislemleri/perakende-fatura-detay/perakende-fatura-detay';
import { HareketdetayPage } from '../CariIslemleri/hareketdetay/hareketdetay';

/**
 * Generated class for the GunlukCariRaporPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

 
@Component({
  selector: 'page-gunluk-cari-rapor',
  templateUrl: 'gunluk-cari-rapor.html',
})
export class GunlukCariRaporPage {

  @ViewChild('sideNavUrunAra') sideNav;
 
  tarih1: any;
  tarih2: any;
  toplamAlacak:number=0;
  toplamBorc:number=0;
  toplamBakiye:number=0;
  GirisIslemiTutari: number = 0;
  CikisIslemiTutari: number = 0;
  GirisCikisFarki: number = 0;
  KasaHareketleri = [];
  tarihfilteraktifmi: number = 0;
  girishareketlerilistesi = [];
  cikishareketlerilistesi = [];
  chartVar: any;
  gelirgiderSegment: any;
  sol_segment: any;
  KasaListesi = [];
  aranan="";
  vwCari: any = {};
  Cari: any = { ID: "" };
  take:number=100;
  skip:number=0;
  baslangic:any;
  bitis:any;
  kullaniciyetkiseviyesi: any;
  dateRange: {
    from: Date
    to: Date
  } = {
      from: this.tarih1,
      to: this.tarih2
    };
  type: 'string'; // 'string' | 'js-date' | 'moment' | 'time' | 'object'
  optionsRange: CalendarComponentOptions = {
    from: new Date(2016, 1, 1),
    pickMode: 'range',
    color: "primary",
    monthPickerFormat: ["Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran", "Tem", "Agust", "Eylül", "Ekim", "Kasım", "Aralık"]
  };

  constructor(public navCtrl: NavController,
    public bllOrtak: BllOrtak,
    public ortak: Ortak,
    public modalCtrl:ModalController,
    public actionSheetCtrl:ActionSheetController,
    public navParams: NavParams) {
      var tzoffset = (new Date()).getTimezoneOffset() * 60000; //offset in milliseconds
      var localISOTime = (new Date(Date.now() - tzoffset)).toISOString().slice(0,-1);
          this.tarih1 = this.ortak.tarih(this.ortak.storageGunTarihiGetir);
          this.tarih2 = localISOTime;
          if (navParams.get("vwCari") != null) {
            this.vwCari = navParams.get("vwCari");
            var data = new FormData();
            data.append("cari_id", this.vwCari.ID);
            this.bllOrtak.islem(data, "CariGetirByID", "", false).then(a => {
              var Sonuc = <any>a;
              this.Cari = Sonuc.SonucObject;
      
            }
            )
  }
  this.kullaniciyetkiseviyesi = this.ortak.kullaniciType;
}

  ionViewDidLoad() {
    this.dateRange.from = this.ortak.storageGunTarihiGetir;
    this.dateRange.to = this.ortak.storageGunTarihiGetir;
    this.closeNav();
    this.RaporGetir();
    this.gelirgiderSegment = "tümü";
    this.kasaListesi();
  }
  openNav() {
    let sideElement = this.sideNav.nativeElement
    sideElement.style.display = "block";
  }
  closeNav() {
    let sideElement = this.sideNav.nativeElement;
    sideElement.style.display = "none";
  }

   
  RaporGetir() {
    this.tarihfilteraktifmi = 1;
    var formData = new FormData();
    this.toplamAlacak=0;
    this.toplamBakiye=0;
    this.toplamBorc=0;
   
     formData.append("tarih1", this.ortak.tarih(this.tarih1));
    formData.append("tarih2",this.ortak.tarih(this.tarih2));
  
    formData.append("tarihfilter", this.tarihfilteraktifmi.toString());
  console.log("tarih1", this.ortak.tarih(this.tarih1));
  console.log("tarih2",this.ortak.tarih(this.tarih2));
  
  console.log("tarihfilter", this.tarihfilteraktifmi.toString());
   
    this.bllOrtak.islem(formData, "CariHareketleriGunlukRapor", "", true).then(a => {
      var sonuc = <any>a;
      this.KasaHareketleri = sonuc.SonucObject;
 
      console.log("gelenListe",sonuc.SonucObject);
     
      
      this.CikisIslemiTutari = 0;
      this.GirisIslemiTutari = 0;
      this.girishareketlerilistesi = this.KasaHareketleri.filter(a => a.IslemTuru == 4 || a.IslemTuru == 10);
      this.girishareketlerilistesi.forEach(element => {
        this.GirisIslemiTutari += parseFloat(element.Tutar.toString());
        if (this.GirisIslemiTutari == null) {
          this.GirisIslemiTutari = 0;
        }
      })
      this.cikishareketlerilistesi = this.KasaHareketleri.filter(b => b.IslemTuru == 5 || b.IslemTuru == 11);
      this.cikishareketlerilistesi.forEach(element => {
        this.CikisIslemiTutari += parseFloat(element.Tutar.toString());
        this.GirisCikisFarki = this.GirisIslemiTutari - this.CikisIslemiTutari;
        this.closeNav();

      })
  
    })

  }
  kasaListesi() {
    var formData = new FormData();
    formData.append("aranan", this.aranan);
    formData.append("skip", this.skip.toString());
    formData.append("take", this.take.toString());
    this.bllOrtak.islem(formData, "KasaListesi", "", false).then(a => {
      var sonuc = <any>a;
      this.KasaListesi = sonuc.SonucObject;
     
    })
  }
  DetaylariGoster(hareket)
  {
    if(hareket.IslemTuru==12||hareket.IslemTuru==13)
    {
      this.navCtrl.push(PerakendeFaturaDetayPage,{vcarihar:hareket});
 
      this.ionViewDidLoad();
     
  }
  else{
    let modal = this.modalCtrl.create(HareketdetayPage, { vwHareket: hareket });
    modal.onDidDismiss(data => {
      this.ionViewDidLoad();
    })
    modal.present();
  }
  }
  Cikart() {
    var data = [];
    this.KasaHareketleri.forEach(rapor => {
      data.push({
        "Belge No": rapor.BelgeNo,
        "Tür": rapor.Satirtipi ,
        "Cari ADI": rapor.Definition_,
        "Slsman":rapor.SlsMan,
        "Kasa":rapor.Name,
        "Açıklama":rapor.Text,
        "IslemTarihi":rapor.IslemTarihi,
        "Tutar":rapor.Tutar.toFixed(2),
        
      })
    
    });
    this.ortak.ExportExcel(data, "Hareketler - ").then(a => {
    }).catch(x => {
    });
  }

  hareketsil(hareket) {
    if (this.kullaniciyetkiseviyesi == 1) {
      this.ortak.showBasicAlert("Uyarı", "Bu İşlemi Yapmaya Yetkiniz Yoktur!!!, Lütfen Yöneticiye Başvurunuz!!");
    }
    else if (this.kullaniciyetkiseviyesi == 2)
      this.ortak.showConfirmAlert("Uyarı", "Kayıt silinecektir. Devam etmek istiyor musunuz? Dikkatli Olun!!!").then(k => {
        var formData = new FormData();
        formData.append("ID", hareket.ID);
       
        this.bllOrtak.islem(formData, "HareketSil", "", false).then(a => {
          var sonuc = <any>a;
          
          if (sonuc.Sonuc == 1) {
            this.ortak.showBasicAlert("Başarılı", "Kayıt Başarılı Bir Şekilde Silindi");
            this.RaporGetir();
          }
          if (sonuc.Sonuc != 1) {
            this.ortak.showBasicAlert("Hata", "Beklenmedik bir hata oluştu");

          }

        }).catch(x => {
         
        })

      })

  }
  Islemler(Hareket) {
    const actionSheet = this.actionSheetCtrl.create({
      title: 'Hareket  İşlemleri',
      buttons: [
       
        {
          text: 'Detaylar',
  
          handler:()=>{
            this.DetaylariGoster(Hareket);
          }
         
        },
        {
          text: 'Kaydı Sil',
          handler: () => {
            this.hareketsil(Hareket);
            this.RaporGetir();
          }
        },
        {
          text: 'İptal ',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        }
      ]
    });
    actionSheet.present();
  }
  HareketiSil(Hareket)
  {
    this.ortak.showConfirmAlert("Uyarı", "Kayıt silinecektir. Devam etmek istiyor musunuz?").then(k => {
      var formData = new FormData();
      
      formData.append("ID", Hareket.ID);
      formData.append("hareket",Hareket.BelgeNo);
      this.bllOrtak.islem(formData, "HareketSil", "", true).then(a => {
        var sonuc = <any>a;
        if (sonuc.Sonuc == 1) this.ortak.showBasicAlert("Başarılı", "İşlem Başarılı");
        this.RaporGetir();


      }).catch(x => {

        this.ortak.showErrorAlert();
      })
    })
     
  }

  HareketiDuzenle(Hareket)
{

}

}



// WEBPACK FOOTER //
// ./src/pages/gunluk-cari-rapor/gunluk-cari-rapor.ts